/**
 * Used for determining the correct input `type` in the `TextInput` component
 */
export var getAdornmentInputType = function (_a) {
    var isMasked = _a.isMasked, adornment = _a.adornment;
    var isNotPasswordMask = !adornment ||
        (typeof adornment === 'string' && adornment !== 'passwordMask') ||
        (typeof adornment === 'object' &&
            adornment.variant !== 'passwordMask');
    if (isNotPasswordMask)
        return undefined;
    if (isMasked)
        return 'password';
    return 'text';
};
export var parseAdornmentOpts = function (opts) {
    if (!opts)
        return {};
    if (typeof opts === 'string')
        return { variant: opts };
    return { options: opts };
};
//# sourceMappingURL=utils.js.map